/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `client` - Client
* `project_client` - Project client
* `partner` - Partner
* `staff` - Staff
* `child` - Child
* `parent` - Parent
 */
export type OrganizationAccountTypeEnum = typeof OrganizationAccountTypeEnum[keyof typeof OrganizationAccountTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationAccountTypeEnum = {
  client: 'client',
  project_client: 'project_client',
  partner: 'partner',
  staff: 'staff',
  child: 'child',
  parent: 'parent',
} as const;
